import { createAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { TaskSourceType } from 'api/tasks';
export const createSpaceTabSagaAction = createAction('spaceTabs/createSpaceTabSagaAction');
export const createSpaceTabSuccessSagaAction = createAction('spaceTabs/createSpaceTabSuccessSagaAction');
export const deleteSpaceTabSagaAction = createAction('spaceTabs/deleteSpaceTabSagaAction');
export const updateSpaceTabSagaAction = createAction('spaceTabs/updateSpaceTabSagaAction');
export const fetchSpaceTabSagaAction = createAction('spaceTabs/fetchSpaceTabSagaAction');
export const spaceTabSuccessSagaAction = createAction('spaceTabs/spaceTabSuccessSagaAction');
function withPayloadType() {
    return (params)=>({
            payload: {
                ...params,
                task: {
                    ...params.task,
                    taskId: moment().valueOf(),
                    source: {
                        sourceType: TaskSourceType.SpaceTab,
                        sourceId: params.spaceTabId
                    }
                }
            }
        });
}
export const createTaskFromSpaceTabSagaAction = createAction('spaceTabs/createTaskFromSpaceTabSagaAction', withPayloadType());
export const deleteTaskFromSpaceTabSagaAction = createAction('spaceTabs/deleteTaskFromSpaceTabSagaAction');
